import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import styled from 'styled-components';

import CoreSvg from 'shared/CoreSvg';
import Icon from 'shared/icons';
import CoreTag from 'shared/tag/CoreTag';
import style from 'styles/styled-components/style';

interface ITopContentFooter {
	data: any[];
	page: number;
	filter_page?: number;
	setPage?: React.Dispatch<React.SetStateAction<number>>;
	useQuery?: boolean;
}

const SimpleTableFooter = ({
	data,
	page,
	filter_page = 5,
	setPage,
	useQuery = false,
}: ITopContentFooter) => {
	const [searchParams, setSearchParams] = useSearchParams();
	/** 총 페이지 수를 구하는 함수 */
	const getTotalPageCount = (match_count: number) => Math.ceil(match_count / filter_page);

	/** 현재 페이지가 지금 보이는 페이지 리스트(길이 5)에서 몇 번째 위치인지 */
	const getPageLocationInPageList = (current_page: number) => Math.ceil(current_page / 5);

	// 총 페이지 수
	const [total_page, setTotalPage] = useState(
		data && data?.length ? getTotalPageCount(data?.length) : 1,
	);
	// 현재 페이지의 페이지 리스트 내 위치 (5로 나누었을 때 나오는 페이지 리스트 중 몇 번째에 위치하고 있는지)
	const [current_page_list, setCurrentPageList] = useState(
		getPageLocationInPageList(page) ?? 1,
	);

	// 비동기로 인해 초기 값으로 state가 세팅되지 않았을 경우 다시 세팅
	useEffect(() => {
		setTotalPage(getTotalPageCount(data?.length));
		setCurrentPageList(getPageLocationInPageList(page));

		if (useQuery) {
			if (total_page < page) {
				searchParams.set('pg', '1');
				setSearchParams(searchParams, { replace: true });
			}
		}
	}, [page, data]);

	// useQuery를 사용하는데 page가 없을경우 1로 설정
	// useEffect(() => {
	// 	if (useQuery) {
	// 		if (searchParams.get('pg') === null) {
	// 			searchParams.set('pg', '1');
	// 			setSearchParams(searchParams, { replace: true });
	// 		}
	// 	}
	// }, []);

	// searchparams를 이용해 페이지를 이동하는 함수
	const setPageWithQuery = (page: number) => {
		if (useQuery) {
			searchParams.set('pg', page.toString());
			setSearchParams(searchParams, { replace: true });
		} else if (setPage) setPage(page);
	};

	return (
		<Grid flex="center">
			<TablePageButtonGroup>
				{/* 페이지 리스트 왼쪽으로 이동하는 버튼 */}
				{current_page_list > 1 && (
					<CoreSvg _onClick={() => setCurrentPageList((state) => state - 1)}>
						<Icon.ArrowLeft />
					</CoreSvg>
				)}
				{/* 페이지 리스트가 2번째 이상일 때 1페이지 버튼과 버튼그룹 사이의 말 줄임 */}
				{current_page_list > 1 && total_page > 5 && (
					<>
						<CoreTag
							tag_type="num"
							num={1}
							color_type="gray"
							_onClick={() => setPageWithQuery(1)}
						/>
						<span>...</span>
					</>
				)}
				{/* 페이지 버튼 그룹 - 메인 5개 */}
				{Array(
					total_page - current_page_list * 5 >= 0
						? 5
						: total_page - (current_page_list - 1) * 5 > 0
						? total_page - (current_page_list - 1) * 5
						: 5,
				)
					.fill(null)
					.map((item, idx) => {
						const current_num = idx + 1 + (current_page_list - 1) * 5;
						return (
							<CoreTag
								key={current_num}
								tag_type="num"
								num={current_num}
								color_type={current_num === page ? 'black' : 'gray'}
								_onClick={() => setPageWithQuery(current_num)}
							/>
						);
					})}
				{/* 페이지 리스트가 1번째 일 때 마지막 페이지 버튼과 버튼그룹 사이의 말 줄임 */}
				{current_page_list === 1 && total_page > 5 && (
					<>
						<span>...</span>
						<CoreTag
							tag_type="num"
							num={total_page}
							color_type="gray"
							_onClick={() => setPageWithQuery(total_page)}
						/>
					</>
				)}
				{/* 페이지 리스트 오른쪽으로 이동하는 버튼 */}
				{getPageLocationInPageList(total_page) > current_page_list && (
					<CoreSvg _onClick={() => setCurrentPageList((state) => state + 1)}>
						<Icon.ArrowRight />
					</CoreSvg>
				)}
			</TablePageButtonGroup>
		</Grid>
	);
};

const { Grid } = style;

const TablePageButtonGroup = styled.div`
	${({ theme }) => theme.common.flexBetween};

	& > span:not(:last-child) {
		${({ theme }) => theme.typo.body.p_bold};
		margin-right: 16px;
	}

	& > div:not(:last-child) {
		margin-right: 16px;
	}
`;

export default SimpleTableFooter;
